import { Selection } from './Selection'

export enum ShopIdentifier {
  DE = 1,
  UK = 2,
  FR = 5,
  NL = 6,
  IT = 7,
  AU = 8,
  ES = 10,
  PL = 11,
  US = 12,
  DK = 13,
  SE = 14
}

export enum CurrencySymbol {
  USD = '$',
  AUD = '$',
  EUR = '€',
  GBP = '£',
  INR = '₹'
}

export type IFieldOption = {
  id: string
  name: string
  key: string
  description?: string
  icon: string
  unit?: string
  min?: string
  max?: string
  dimension?: string
  disabled?: IExcludeOption[]
  lock?: number
  warning?: string
  subText?: string
  nextFieldId?: string
  relatedField?: string
  relatedFieldId?: string
  price?: string
  label?: string
  type?: 'default' | 'singleThumb'
  textUpper?: string
  textLower?: string
  rate?: string
  placeholder?: string
  surcharge?: number
  priceVariant?: string
}

export type IExcludeOption = {
  key: string
  value: number
}

export type FieldType =
  | 'select-radio'
  | 'input-number'
  | 'select-radio-vertical'
  | 'textarea'
  | 'checkbox'
  | 'range'
  | 'select-card-checkbox'
  | 'select-radio-basic'

export type IField = {
  key: string
  displayName: string
  hint?: string
  dimension?: string
  type: FieldType
  options: IFieldOption[]
  exclude?: IExcludeOption[]
  force_value?: {
    id: string
    name: string
    key: string
    value: string
    nextFieldId: string
    relatedFieldId: string
    relatedField: string
  }
  error_message?: string
  description?: string
}

export type IPriceTable = {
  quantity: number
  totalPrice: number
  unitPrice: number
  highlight?: boolean
}

export type IPrice = {
  numberOfSheets: number
  total: number
  dateStandard: string
  dateExpress: string
  dateSuperExpress: string
  priceTable: IPriceTable[]
}

export type IPricesQuery = {
  price: IPrice
  // Properties of the priced job. `currency` is the currency the prices in
  // this response are calculated in.
  jobProps?: {
    currency?: string
  }
  calculatorFields: IField[]
  initialSelection: Selection
  optionFields: IField[]
}

export type IMaterial = {
  attribute_id: number
  certificate: string
  glue_id: number
  image_url: string
  liquid_resistance: number
  max_temperature: number
  min_temperature: number
  recommendation: string
  name?: string
}
